export default "__VITE_ASSET__ofPF4PTr__"